(function($, window, document, pageLoadedQueue) {
    pageLoadedQueue.push(function() {
        if ($('.fileListFilter').length > 0) {
            $('.filterFilesAuthor').on('change', function (e) {
                this.form.submit()
            });
            $('.filterFilesFileExtension').on('change', function (e) {
                this.form.submit()
            });
            $('.filterFilesDate').on('change', function (e) {
                this.form.submit()
            });
        }
    });
})(jQuery, window, document, window.pageLoadedQueue);
